import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Stack, Text } from '@fluentui/react';
import noSearchResultsImg from '@shared/images/noSearchResultsImg.png';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { TelemetryImage } from './telemetryImage';
import { NoSearchResultsButtons } from './noSearchResultsButtons';
import { logger } from '@src/logger';
export const logTelemetry = (currentPage, actionModifier, telemetryDetails)=>{
    const payload = {
        page: currentPage,
        action: Constants.Telemetry.Action.Search,
        actionModifier: actionModifier,
        details: JSON.stringify(telemetryDetails)
    };
    SpzaInstrumentService.getProvider().probe(Constants.Telemetry.ProbeName.LogInfo, payload);
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier,
        page: payload.page
    });
};
export const NoSearchResults = ({ context, isSearch = false, isFilter = false, entityType = Constants.EntityType.App, currentPage = '', changeSearchText })=>{
    const { previousSearchText } = useSelector(({ search: { previousSearchText } })=>({
            previousSearchText
        }));
    useEffect(()=>{
        const telemetryDetails = {
            message: 'NoSearchResults component is shown to the user',
            entityType,
            isSearch,
            isFilter
        };
        logTelemetry(currentPage, Constants.Telemetry.ActionModifier.NoSearchResultsPage, telemetryDetails);
    }, [
        entityType,
        isFilter,
        isSearch,
        currentPage
    ]);
    return /*#__PURE__*/ _jsxs(Stack, {
        className: "NoSearchResultsContainer",
        tokens: {
            childrenGap: 'l1'
        },
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "center",
                children: /*#__PURE__*/ _jsx(TelemetryImage, {
                    className: "NoSearchResultsImg",
                    src: noSearchResultsImg
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                className: "NoSearchResultsTitle",
                align: "center",
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "NoSearchResultsTitleText",
                    variant: "large",
                    styles: {
                        root: {
                            color: '#323130',
                            fontWeight: '600',
                            lineHeight: '24px'
                        }
                    },
                    children: context.loc('NoSearchResults_NoResultsFound', 'No results found')
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                className: "NoSearchResultsDescription",
                align: "center",
                children: /*#__PURE__*/ _jsx(Text, {
                    className: "NoSearchResultsDescriptionText",
                    variant: "medium",
                    styles: {
                        root: {
                            color: '#605e5c',
                            lineHeight: '20px',
                            whiteSpace: 'pre-wrap',
                            textAlign: 'center',
                            display: 'flex'
                        }
                    },
                    children: previousSearchText ? context.locParams('NoSearchResults_NoResultsFoundDescription', [
                        previousSearchText
                    ], `We couldn't find any results for ${previousSearchText}.\nChange selected filters or try a different search term.`) : context.loc('NoSearchResults_NoResultsFoundDescription_Without_SearchTerm', `We couldn't find any results.\nChange selected filters or try a different search term.`)
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                align: "center",
                children: /*#__PURE__*/ _jsx(NoSearchResultsButtons, {
                    context: context,
                    isSearch: isSearch,
                    isFilter: isFilter,
                    entityType: entityType,
                    currentPage: currentPage,
                    changeSearchText: changeSearchText
                })
            })
        ]
    });
};
